export default {
  label: 'Trimite către',
  counter: '{{current}} din {{max}}',
  default_badge: 'Implicit',
  remove: 'Elimină {{email}}',
  add_back: 'Adaugă la loc',
  empty: 'Adaugă cel puțin un e-mail.',
  add_label: 'Adaugă un e-mail',
  placeholder: 'nume@exemplu.com',
  add: 'Adaugă',
  hint: 'Maximum {{max}} e-mailuri. Fiecare primește propriul e-mail.',
  hint_full: 'Este numărul maxim pentru această listă. Elimină un e-mail pentru a adăuga altul.',
  errors: {
    full: 'Puteți adăuga cel mult {{max}} adrese de e-mail.',
    invalid: 'Introdu un e-mail de forma nume@exemplu.com.',
    duplicate: '{{email}} este deja în listă.',
  },
};
